var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditSkyBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9867 3.465L10.4866 2.00667C10.3126 1.83458 10.0816 1.75 9.85059 1.75C9.61957 1.75 9.38855 1.83458 9.21454 2.00667L2.01405 9.00667C1.74103 9.27208 1.75003 9.91667 1.75003 9.91667V12.25L4.1502 11.9583C4.38121 11.9583 4.87325 11.8388 5.05026 11.6667L11.9867 4.70167C12.3378 4.36042 12.3378 3.80625 11.9867 3.465ZM4.1502 11.0833L2.6501 9.625L9.85059 2.625L11.3507 4.08333L4.1502 11.0833Z",
    fill: "#00B9F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSkyBlue);
export default __webpack_public_path__ + "static/media/edit_sky_blue.a969e45e0419212f2d118493963915d1.svg";
export { ForwardRef as ReactComponent };